import { ComponentType, EventSource, InteractionType, MixpanelEvent } from '../MixPanelTypes';

export type MyContentExport =
  | 'GO_TO_EXPORT_PANEL_FROM_NOTIFICATION'
  | 'LIST_EXPORTS'
  | 'DOWNLOAD_EXPORT'
  | 'RECENT_EXPORT_VIEW_ALL'
  | 'DOWNLOAD_EXPORT_FROM_RECENT_EXPORTS'
  | 'GO_TO_EXPORT_PANEL_FROM_RECENT_EXPORTS';

export const myContentExport: Record<MyContentExport, MixpanelEvent> = {
  GO_TO_EXPORT_PANEL_FROM_RECENT_EXPORTS: {
    eventDescription: 'User clicked export to view details and to navigate to the Export page',
    eventKey: 'recent-export-view-details',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.OVERFLOW_MENU_ITEM_BUTTON
  },
  DOWNLOAD_EXPORT_FROM_RECENT_EXPORTS: {
    eventDescription: 'User clicked download file from recent exports',
    eventKey: 'recent-export-download-file',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.SECONDARY_ACTION
  },
  RECENT_EXPORT_VIEW_ALL: {
    eventDescription: 'User clicked view all to navigate to the Export page',
    eventKey: 'recent-export-view-all',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.PRIMARY_ACTION
  },
  GO_TO_EXPORT_PANEL_FROM_NOTIFICATION: {
    eventDescription: 'User clicked notification and navigated to export page',
    eventKey: 'go-to-export-panel-from-notification',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.NOTIFICATION_ITEM
  },
  LIST_EXPORTS: {
    eventDescription: 'User lists exports',
    eventKey: 'list-exports-from-content-page',
    eventSource: EventSource.VIEW_RENDER,
    interactionType: InteractionType.N_A,
    componentType: ComponentType.N_A
  },
  DOWNLOAD_EXPORT: {
    eventDescription: 'User downloadeds export',
    eventKey: 'download-export',
    eventSource: EventSource.USER_INTERACTION,
    interactionType: InteractionType.CLICK,
    componentType: ComponentType.N_A
  }
} as const;
